// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/plugins/_index.scss
// module id = 70
// module chunks = 0